import React from "react";
import { Home, Map as MapIcon, PhoneCall } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export default function BottomNav() {
  const { t } = useTranslation();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  const items = [
    { to: "/", icon: Home, label: t("nav.home"), testid: "bottom-nav-home", exact: true },
    { to: "/mappa", icon: MapIcon, label: t("nav.map"), testid: "bottom-nav-map" },
    { to: "/contatti", icon: PhoneCall, label: t("nav.contacts"), testid: "bottom-nav-contacts" },
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 z-40 w-full max-w-[560px] bg-ivory-50/90 backdrop-blur-xl border-t border-ink-200/40"
    >
      <div className="flex items-stretch justify-around pt-2.5 pb-safe px-4">
        {items.map(({ to, icon: Icon, label, testid, exact }) => (
          <NavLink
            key={to}
            to={to}
            end={exact}
            data-testid={testid}
            className={({ isActive }) =>
              cn(
                "relative flex flex-col items-center gap-1 px-4 py-1.5 rounded-full transition-colors",
                isActive ? "text-bronze-500" : "text-ink-300 hover:text-ink-700"
              )
            }
          >
            {({ isActive }) => (
              <>
                <Icon strokeWidth={1.5} className="w-[19px] h-[19px]" />
                <span className="text-[9.5px] tracking-overline font-semibold">{label}</span>
                {isActive && (
                  <span className="absolute -top-[9px] left-1/2 -translate-x-1/2 h-[3px] w-8 rounded-full bg-bronze-400" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
